var map = {
	"./2012.json": 827,
	"./2013.json": 304,
	"./2014.json": 217,
	"./2015.json": 110,
	"./2016.json": 551,
	"./2017.json": 188,
	"./2018.json": 301,
	"./2019.json": 618,
	"./2020.json": 982,
	"./2021.json": 937,
	"./2022.json": 956,
	"./2023.json": 343,
	"./2024.json": 298,
	"./2025.json": 813
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 55;
module.exports = webpackAsyncContext;